export enum StorageKeys {
  token = 'localStorage.keys.token',
}
